import { userPermission } from '@/constants';
import HubList from '@/views/HubManagement/HubList/index.vue';
import HubManagementCreate from '@/views/HubManagement/HubCreate/index.vue';
import HubManagementDetail from '@/views/HubManagement/HubDetail/index.vue';
import HubManagementEdit from '@/views/HubManagement/HubEdit/index.vue';
import { pageAuthorization } from '@/router-middleware';
import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'hub-management',
        name: routeName.HUB_MANAGEMENT,
        component: HubList,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization(userPermission.P_GET_HUB()),
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'hub-management/create',
        name: routeName.HUB_MANAGEMENT_CREATE,
        component: HubManagementCreate,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization([
                    userPermission.P_CREATE_HUB,
                ]),
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'hub-management/:hubId',
        redirect: {
            name: routeName.HUB_MANAGEMENT_DETAIL,
        },
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'hub-management/:hubId/detail',
        name: routeName.HUB_MANAGEMENT_DETAIL,
        component: HubManagementDetail,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'hub-management/:hubId/:pageType(basic-info|adjustment-operation-setting|worker-operation-setting)',
        name: routeName.HUB_MANAGEMENT_EDIT,
        component: HubManagementEdit,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization([
                    userPermission.P_EDIT_HUB,
                ]),
                ...basicOptions.middleware,
            ],
        },
    },
];
